// Ширины колонок таблицы по содержимому (`lib/tableColumns.ts`). Текст меряем в
// DOM — скрытыми строками тем же кеглем и с теми же полями ячейки, что у самой
// таблицы. Меряем и ширину таблицы, и текст через getBoundingClientRect: на
// холсте весь телефон масштабирован `zoom`, и оба замера масштабируются
// одинаково, а наружу уходят ПРОЦЕНТЫ — от масштаба они не зависят.
import { useLayoutEffect, useState } from 'react'
import { tableColumnWidths } from '@/features/editor/lib/tableColumns'

const sameWidths = (a: number[] | null, b: number[] | null): boolean =>
  a === b || (a !== null && b !== null && a.join() === b.join())

/** Проценты ширины колонок; `null` — замера ещё нет (или jsdom без раскладки),
 *  тогда таблица остаётся на HTML-авто. */
export const useTableColumns = (frame: HTMLElement | null, texts: string[][]) => {
  const [percents, setPercents] = useState<number[] | null>(null)
  const signature = JSON.stringify(texts)
  useLayoutEffect(() => {
    if (!frame) return
    const measure = () => {
      const available = frame.getBoundingClientRect().width
      const widths = new Map<string, number>()
      frame.querySelectorAll<HTMLElement>('[data-measure]').forEach((el) => {
        widths.set(el.dataset.measure ?? '', el.getBoundingClientRect().width)
      })
      const columns =
        available > 0 ? tableColumnWidths({ texts, widths, cellPadding: 0, available }) : []
      const next = columns.length ? columns.map((width) => (width / available) * 100) : null
      setPercents((prev) => (sameWidths(prev, next) ? prev : next))
    }
    measure()
    const ro = new ResizeObserver(measure)
    ro.observe(frame)
    // Шрифт канваса (Madefor) грузится с Google Fonts: замер до его загрузки
    // считал бы ширины по запасной гарнитуре.
    void document.fonts?.ready.then(measure)
    return () => ro.disconnect()
    // texts описан signature: новая матрица с тем же текстом не перемеряет.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [frame, signature])
  return percents
}
